import Vue from 'vue'
import App from './App.vue'
import Spinner from "./components/spinner";
import VueTheMask from 'vue-the-mask'
import money from 'v-money'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { utils } from "./utils.js";

Vue.prototype.$utils = utils;
Vue.use(VueTheMask)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(money, {precision: 4})

Vue.use(Spinner);
Vue.component("SpinnerLoad", Spinner);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
